(function (window, $) {
  var randomPrize = window.randomPrize;
  var _numberOfTriesLeft = 0;
  var _gameActive = false;
  var _coin = false;
  var _coinPath = [];
  var _chanceOfWinning = 100;
  var _willWin = false;
  var _winningProduct = false;
  var $wrapper = $('.js-holiday-digital-grabber-game-v2');
  var _nodes = {
    main: document.getElementById('tower-of-gifts'),
    arena: document.getElementById('coin-drop-area'),
    arenaVideo: document.getElementById('waterfall-bg'),
    btnPlay: document.getElementById('btn-play-game'),
    textBetweenButtons: document.querySelector('.game-win-between-text'),
    btnPlayAgain: document.getElementById('btn-win-play-again'),
    btnLosePlayAgain: document.getElementById('btn-lose-try-again'),
    btnApplyOffer: document.getElementById('btn-win-apply-offer'),
    tries: document.querySelectorAll('span.number-of-tries'),
    triesPlural: document.querySelectorAll('span.game-tries-plural'),
    gameCoins: document.querySelectorAll('.game-coins'),
    gameCoinsWin: document.getElementById('game-coins-popup'),
    popup: document.getElementById('game-popup-area'),
    gameHeader: document.querySelector('.game-header'),
    gameTitle: document.querySelector('.game-title'),
    gamePopup: document.getElementById('game-popup-box'),
    winPopup: document.querySelector('.game-win-popup'),
    losePopup: document.querySelector('.game-lost-popup'),
    winOfferMessage: document.getElementById('game-win-offer-message'),
    winOfferCopy: document.getElementById('game-win-offer-copy'),
    winOfferImage: document.getElementById('game-win-image'),
    intro: document.getElementById('game-intro'),
    btnIntro: document.querySelector('section#game-intro a'),
    gameFormatter: $('.game-formatter-wrapper'),
    gameCoinImageWrapper: $('.js-active-game-coin')
  };
  var _settings = {
    afterApplyRedirect: document.getElementById('game_after_apply_redirect').value,
    coinImage: document.getElementById('game_coin_img').value,
    coinAnimImage: document.getElementById('game_coin_anim_img').value,
    arenaBgMobile: document.getElementById('arena_bg_mobile').value,
    arenaBgDesktop: document.getElementById('arena_bg_desktop').value,
    delayTime: parseInt(document.getElementById('game_delay_time').value, 10) || 1,
    totalTries: document.getElementById('no_of_tries').value || 3,
    animateBetweenPoints: $wrapper.attr('data-animate-between-points') || 0,
    pcArenaWidth: $wrapper.attr('data-arena-width') || 1,
    pcArenaHeight: $wrapper.attr('data-arena-height') || 1,
    mobileArenaWidth: $wrapper.attr('data-mobile-arena-width') || 1,
    mobileArenaHeight: $wrapper.attr('data-mobile-arena-height') || 1,
    pcWinCoordinates: $wrapper.attr('data-pc-coin-winning-coordinates') || [],
    pcFailCoordinates: $wrapper.attr('data-pc-coin-failed-coordinates') || [],
    mobileWinCoordinates: $wrapper.attr('data-mobile-coin-winning-coordinates') || [],
    mobileFailCoordinates: $wrapper.attr('data-mobile-coin-failed-coordinates') || []
  };
  var loadImages = function () {
    if (_settings.pcWinCoordinates.length) {
      var coordData = JSON.parse(_settings.pcWinCoordinates);

      for (var i in coordData) {
        _nodes.gameCoinImageWrapper.append('<img src="' + coordData[i].img + '" alt="" class="js-point-' + coordData[i].point + ' hidden" />');
      }
    }
  };

  loadImages();

  var analytics = function gameAnalytics($track) {
    if (!window['site']) {
      return;
    }

    if ('track' in window.site && 'evtLink' in window.site.track) {
      window.site.track.evtLink($track);

      return true;
    } else {
      return;
    }
  };
  /**
   * This function updates the number of coins shown on the screen
   *
   * @param {number} triesCount - the number of coins left
   * @returns {false} none
   */
  var updateNumberOfTries = function gameUpdateNumberOfTries(triesCount) {
    var tries = triesCount || _numberOfTriesLeft;

    // Updates any text reference to number of tries
    for (var i = 0; i < _nodes.tries.length || 0; i++) {
      _nodes.tries[i].textContent = String(tries);
    }

    for (var _i = 0; _i < _nodes.triesPlural.length; _i++) {
      _nodes.tries[_i].parentNode.style.display = tries === 0 ? 'none' : 'inline';
    }

    updateDisplayTries(tries);
  };
  var updateDisplayTries = function (tries) {
    for (var c = 0; c < _nodes.gameCoins.length; c++) {
      _nodes.gameCoins[c].innerHTML = '<!-- ' + tries + ' coins -->';

      for (var l = 0; l < tries; l++) {
        var coinImg = document.createElement('LI');

        _nodes.gameCoins[c].appendChild(coinImg);
      }
    }
  };
  var playGameStart = function playGame(event) {
    if (_gameActive) {
      return;
    }

    if (event) {
      event.preventDefault();
    }

    hidePopups();
    _nodes.gameTitle.classList.add('hidden');
    randomPrize.setNewPrize();
    _gameActive = true;

    _coin = document.createElement('div');

    _coin.classList.add('active-game-coin');
    _willWin = _numberOfTriesLeft - 1 < 1 ? true : Math.random() * 100 < _chanceOfWinning;
    if (_settings.pcWinCoordinates.length) {
      _coinPath = processCoordinates(_willWin);
    } else {
      _coinPath = defineCoinPath(_willWin);
    }
    _coin.style.left = _coinPath[0].x + 'px';
    _coin.style.top = _coinPath[0].y + 'px';

    _nodes.arena.appendChild(_coin);
    $(_coin).append(_nodes.gameCoinImageWrapper.removeClass('hidden'));

    $(_coin).find('img').addClass('hidden');
    $(_coin).find('img.js-point-0').removeClass('hidden');
    updateNumberOfTries(--_numberOfTriesLeft);

    randomPrize.setNumberOfTriesCookie(_settings.totalTries - _numberOfTriesLeft + 1);

    setTimeout(function () {
      gameLoop();
    }, _coinPath[0].t || 500);

    analytics({
      event_name: 'siteGame_play',
      event_category: 'Site Game',
      event_action: 'Play',
      event_label: 1 + (randomPrize.getNumberOfTries() - _numberOfTriesLeft)
    });
  };
  /**
   * Shows the Win Box
   *
   * @param {Object} $fields - fields used to populate the win box
   * @returns {bool} false
   */
  var showWinBox = function gameShowWinBox($fields) {
    if (!$fields) {
      return false;
    }

    _coin.classList.add('hidden');

    setWinData($fields);

    setWinState();

    analytics({
      event_name: 'siteGame_win',
      event_category: 'Site Game',
      event_action: 'Win',
      event_label: 1 + (randomPrize.getNumberOfTries() - _numberOfTriesLeft),
      product_impression_list: ['/siteGame'],
      product_impression_position: '1',
      product_impression_id: [_winningProduct]
    });
  };
  var setWinData = function ($fields) {
    if (!$fields.confirmMessage || $fields.confirmMessage === 'undefined') {
      _nodes.winOfferMessage.style.display = 'none';
    } else {
      _nodes.winOfferMessage.innerHTML = $fields.confirmMessage;
    }

    if (!$fields.description || $fields.description === 'undefined') {
      _nodes.winOfferCopy.style.display = 'none';
    } else {
      _nodes.winOfferCopy.innerHTML = $fields.description;
    }

    _winningProduct = $fields['product'] || false;
  };
  var setWinState = function () {
    _nodes.losePopup.classList.remove('active');

    _nodes.winPopup.classList.add('active');

    _nodes.gameTitle.classList.remove('hidden');

    _nodes.gameCoinsWin.classList.add('hidden');

    if (_numberOfTriesLeft < 1) {
      _nodes.btnPlayAgain.classList.add('hidden');

      if (_nodes.textBetweenButtons) {
        _nodes.textBetweenButtons.classList.add('hidden');
      }
    }

    _nodes.popup.classList.remove('hidden');
  };
  var showLoseBox = function gameShowLoseBox() {
    _nodes.losePopup.classList.add('active');

    _nodes.winPopup.classList.remove('active');

    _nodes.popup.classList.remove('hidden');

    _nodes.gameTitle.classList.remove('hidden');

    _nodes.gameCoinsWin.classList.remove('hidden');

    _coin.classList.add('hidden');

    analytics({
      event_name: 'siteGame_win',
      event_category: 'Site Game',
      event_action: 'Lose',
      event_label: 1 + (randomPrize.getNumberOfTries() - _numberOfTriesLeft)
    });
  };
  var hidePopups = function gameHidePopups() {
    _nodes.losePopup.classList.remove('active');

    _nodes.winPopup.classList.remove('active');

    _nodes.gameHeader.classList.remove('hidden');

    _nodes.popup.classList.add('hidden');
  };
  var showPrize = function gameShowPrize() {
    _gameActive = false;

    _nodes.gameHeader.classList.add('hidden');

    if (_willWin) {
      showWinBox(randomPrize.getWinningOffer());
    } else {
      showLoseBox();
    }
  };
  var afterApplyOffer = function gameAfterApplyOffer() {
    window.location.href = _settings.afterApplyRedirect || '/';
  };
  var defineCoinPath = function gameDefineCoinPath(willWin) {
    var arena = _nodes.arena.getBoundingClientRect();
    var apx = arena.width / 100;
    var apy = arena.height / 100;
    var rnd = {
      x1: Math.random() * 3,
      x2: Math.random() * 3,
      x3: Math.random() * 8,
      x4: Math.random() * 4
    };

    _nodes.gameFormatter.css('padding-top', (arena.height / arena.width) * 100 + '%');

    if (Unison.fetch.now().name === 'small') {
      var returnArray = [
        {
          x: apx * (47 + rnd.x1),
          y: apy * 5,
          t: 0,
          o: 0
        },
        {
          x: apx * (47 + rnd.x1),
          y: apy * 18.6,
          t: 1000,
          e: 'easeOutBounce'
        },
        {
          x: apx * (47 + rnd.x1),
          y: apy * 18.6,
          t: 200
        },
        {
          x: apx * (50 - rnd.x2),
          y: apy * 24,
          t: 700,
          e: 'easeOutBounce'
        },
        {
          x: apx * (40 + rnd.x3),
          y: apy * 30.5,
          t: 700,
          e: 'easeOutBounce'
        },
        {
          x: apx * (48 - rnd.x4),
          y: apy * 38.5,
          t: 1000,
          e: 'easeOutBounce'
        }
      ];

      if (willWin) {
        returnArray.push({
          x: apx * 57,
          y: apy * 47,
          t: 1000,
          e: 'easeOutBounce'
        });
        returnArray.push({
          x: apx * 57,
          y: apy * 67.5,
          t: 1000,
          e: 'easeOutCubic'
        });
        returnArray.push({
          x: apx * 57,
          y: apy * 69.5,
          t: 300,
          o: 0
        });
      } else {
        returnArray.push({
          x: apx * 42,
          y: apy * 46,
          t: 700,
          e: 'easeOutBounce'
        });
        returnArray.push({
          x: apx * 37,
          y: apy * 55,
          t: 700,
          e: 'easeOutBounce'
        });
        returnArray.push({
          x: apx * 30,
          y: apy * 69,
          t: 1000,
          e: 'easeOutBounce'
        });
        returnArray.push({
          x: apx * 26,
          y: apy * 77,
          t: 700,
          e: 'easeOutBounce'
        });
        returnArray.push({
          x: apx * 22,
          y: apy * 88,
          t: 700,
          e: 'easeOutCubic'
        });
      }

      return returnArray;
    } else {
      var returnArrayPc = [
        {
          x: apx * (16.9 + rnd.x1),
          y: apy * 13.3,
          t: 0,
          o: 0
        },
        {
          x: apx * (33.6 + rnd.x1),
          y: apy * 19.6,
          t: 0
        },
        {
          x: apx * (38.7 + rnd.x1),
          y: apy * 34.3,
          t: 0
        },
        {
          x: apx * (51.9 + rnd.x2),
          y: apy * 41.2,
          t: 0
        }
      ];

      if (willWin) {
        returnArrayPc.push({
          x: apx * 55.5,
          y: apy * 57,
          t: 800
        });
        returnArrayPc.push({
          x: apx * 66.6,
          y: apy * 65.8,
          t: 1000
        });
      } else {
        returnArrayPc.push({
          x: apx * 66.7,
          y: apy * 48.3,
          t: 1200
        });
        returnArrayPc.push({
          x: apx * 80.4,
          y: apy * 51.6,
          t: 1000
        });
        returnArrayPc.push({
          x: apx * 99.8,
          y: apy * 61.1,
          t: 800
        });
      }

      return returnArrayPc;
    }
  };
  var gameLoop = function gameAnimationLoop() {
    var point = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    animateCoin(point);
  };
  var animateCoin = function (point) {
    $(_coin).find('img').addClass('hidden');
    $(_coin).find('img.js-point-' + point).removeClass('hidden');
    if (_settings.animateBetweenPoints) {
      $(_coin).animate(
        {
          left: _coinPath[point].x,
          top: _coinPath[point].y,
          opacity: _coinPath[point].o || _coinPath[point].o === 0 ? _coinPath[point].o : 1
        },
        _coinPath[point].t || 500,
        _coinPath[point].e || 'linear',
        function () {
          if (point + 1 >= _coinPath.length) {
            setTimeout(showPrize, _settings.delayTime * 1000);
          } else {
            gameLoop(point + 1);
          }
        }
      );
    } else {
      $(_coin).css({
        left: _coinPath[point].x,
        top: _coinPath[point].y,
        opacity: _coinPath[point].o || _coinPath[point].o === 0 ? _coinPath[point].o : 1
      });
      setTimeout(function () {
        if (point + 1 >= _coinPath.length) {
          setTimeout(showPrize, _settings.delayTime * 1000);
        } else {
          gameLoop(point + 1);
        }
      }, _coinPath[point].t || 500);
    }
  };
  var processCoordinates = function (willWin) {
    var isMobile = Unison.fetch.now().name === 'small' ? 1 : 0;
    var eachCoordinates;

    if (willWin) {
      try {
        if (isMobile) {
          eachCoordinates = JSON.parse(_settings.mobileWinCoordinates);
        } else {
          eachCoordinates = JSON.parse(_settings.pcWinCoordinates);
        }
      } catch (err) {
        eachCoordinates = defineCoinPath(willWin);

        return eachCoordinates;
      }
    } else {
      try {
        if (isMobile) {
          eachCoordinates = JSON.parse(_settings.mobileFailCoordinates);
        } else {
          eachCoordinates = JSON.parse(_settings.pcFailCoordinates);
        }
      } catch (err) {
        eachCoordinates = defineCoinPath(willWin);

        return eachCoordinates;
      }
    }
    var arena = _nodes.arena.getBoundingClientRect();
    var apx = arena.width / 100;
    var apy = arena.height / 100;
    var rnd = {
      x1: Math.random() * 3,
      x2: Math.random() * 3,
      x3: Math.random() * 8,
      x4: Math.random() * 4
    };

    if (isMobile) {
      var returnArray = [];

      for (var y in eachCoordinates) {
        var obj = {};
        var thisCoord = eachCoordinates[y];

        obj.x = apx * (((thisCoord.xCoordinateInPixel * 100) / _settings.mobileArenaWidth) + rnd.x1);
        obj.y = apy * ((thisCoord.yCoordinateInPixel * 100) / _settings.mobileArenaHeight);
        obj.t = thisCoord.duration || 0;
        obj.o = thisCoord.opacity || 1;
        obj.img = thisCoord.img || '';
        returnArray.push(obj);
      }

      return returnArray;
    } else {
      var returnArrayPc = [];

      for (var y1 in eachCoordinates) {
        var objPc = {};
        var thisCoordPc = eachCoordinates[y1];

        objPc.x = apx * (((thisCoordPc.xCoordinateInPixel * 100) / _settings.pcArenaWidth) + rnd.x1);
        objPc.y = apy * ((thisCoordPc.yCoordinateInPixel * 100) / _settings.pcArenaHeight);
        objPc.t = thisCoordPc.duration || 0;
        objPc.o = thisCoordPc.opacity || 1;
        objPc.img = thisCoordPc.img || '';
        returnArrayPc.push(objPc);
      }

      return returnArrayPc;
    }
  };
  var init = function gameInit() {
    if (window['innerWidth'] < 640 || window['outerWidth'] < 640) {
      _nodes.arenaVideo['src'] = _settings.arenaBgMobile;
    } else {
      _nodes.arenaVideo['src'] = _settings.arenaBgDesktop;
    }

    if (!window.randomPrize) {
      return;
    }

    // You must re-assign a variable otherwise the load event in Chrome will cause a ref error
    randomPrize = window.randomPrize;

    if (!randomPrize.get24HourCookie()) {
      randomPrize.set24HourCookie();
    }

    if (!randomPrize.getNumberOfTriesCookie()) {
      randomPrize.setNumberOfTriesCookie();
    }

    randomPrize.init(function () {
      _nodes.main.classList.add('load-complete');

      if (randomPrize.isAlreadyPlayed()) {
        showPrize();

        return;
      }

      if (!randomPrize.isGameValidforPlay()) {
        _nodes.gamePopup.style.display = 'flex';
        randomPrize.getUnavailableMessage();

        return;
      }

      _nodes.btnPlay.addEventListener('click', playGameStart);

      _nodes.btnPlayAgain.addEventListener('click', playGameStart);

      _nodes.btnLosePlayAgain.addEventListener('click', playGameStart);

      _nodes.btnApplyOffer.addEventListener('click', function (event) {
        event.preventDefault();

        randomPrize.applyOffer(afterApplyOffer);
      });

      _chanceOfWinning = randomPrize.getWinChance() || 100;
      _numberOfTriesLeft = _settings.totalTries - randomPrize.getNumberOfTries() + 1;

      updateNumberOfTries(_numberOfTriesLeft);

      if (_nodes.btnIntro) {
        _nodes.btnIntro.addEventListener('click', function () {
          _nodes.gameHeader.classList.remove('hidden');
          _nodes.intro.classList.add('hidden');
        });
      }
    });
  };

  window.addEventListener('load', init);

  /*
  * Extend jQuery's easing to include the bezier's we need for the coin animation.
  */
  (function () {
    // t: current time, b: begInnIng value, c: change In value, d: duration
    $.extend($.easing, {
      easeOutCubic: function easeOutCubic(x, t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
      },
      easeOutBounce: function easeOutBounce(x, t, b, c, d) {
        if ((t /= d) < 1 / 2.75) {
          return c * (7.5625 * t * t) + b;
        } else if (t < 2 / 2.75) {
          return c * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + b;
        } else if (t < 2.5 / 2.75) {
          return c * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + b;
        } else {
          return c * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + b;
        }
      }
    });
  })();
})(window, jQuery);
